
export const f_101_formatDateExactly = (isoString) => {
    const date = new Date(isoString);
    const pad = num => String(num).padStart(2, '0');
    
    return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}, ` +
           `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }